var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1158,
    height: 940,
    viewBox: "0 0 1158 940",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1_4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1155,
    height: 678,
    rx: 10
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1155,
    height: 678,
    rx: 10,
    stroke: "black",
    strokeWidth: 28,
    mask: "url(#path-1-inside-1_1_4)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 830,
    height: 650,
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352 439V239L502 339.168L352 439Z",
    fill: "#066AB7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 14,
    width: 305,
    height: 650,
    fill: "#18181B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1093.5,
    cy: 66.5,
    r: 12.5,
    fill: "#696F75"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1052.5,
    cy: 66.5,
    r: 12.5,
    fill: "#696F75"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.5,
    cy: 136.5,
    r: 12.5,
    fill: "#A3D49C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.5,
    cy: 251.5,
    r: 12.5,
    fill: "#D49CCE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 917,
    y: 118,
    width: 198,
    height: 100,
    rx: 26,
    fill: "#272C38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 917,
    y: 239,
    width: 198,
    height: 100,
    rx: 26,
    fill: "#272C38"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1011.5,
    cy: 66.5,
    r: 12.5,
    fill: "#696F75"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 970.5,
    cy: 66.5,
    r: 12.5,
    fill: "#696F75"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929.5,
    cy: 66.5,
    r: 12.5,
    fill: "#696F75"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.5,
    cy: 66.5,
    r: 12.5,
    fill: "#696F75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 598,
    width: 263,
    height: 50,
    rx: 10,
    fill: "#696F75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556,
    y: 678,
    width: 43,
    height: 16,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 842,
    width: 659,
    height: 29,
    rx: 14.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 694V677H661.5V737.5L661 846.5H497V677H575.5V694C572.333 693.667 563.3 694.8 552.5 702C541.7 709.2 536 724.667 534.5 731.5C534.333 745.667 534.1 776.2 534.5 785C534.9 793.8 541 803.333 544 807C548 810.667 557.8 818.6 565 821C572.2 823.4 582.667 823 587 822.5C592.333 821.5 605 817.3 613 808.5C621 799.7 623.667 785.833 624 780C624.167 773 624.4 755.7 624 742.5C623.632 730.371 622.062 724.349 621.141 722.417C621.064 722.279 620.989 722.14 620.914 722C620.406 721.052 619.933 720.052 619.5 719C611.1 698.6 589.667 693.833 580 694Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M661.266 -15.1431C627.443 -37.2131 591.158 -30.5091 563.466 -7.4051C576.514 -16.3221 593.473 -19.2031 609.467 -13.6671L618.62 -10.5001C645.417 -1.2261 659.754 28.2869 650.48 55.0839L625.858 126.229L648.015 173.348L688.782 55.0839C697.726 29.2399 683.336 -0.742102 661.266 -15.1431Z",
    fill: "#959798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.73 149.462L645.453 146.747M661.266 -15.1434C627.443 -37.8794 592.2 -30.5324 564.624 -8.33339H564.91C577.752 -16.5024 609.242 -16.7864 625.901 -7.33339C642.561 2.12061 659.754 28.2866 650.48 55.0846L625.858 126.23L648.015 173.348L688.782 55.0846C697.726 29.2406 683.137 -0.441388 661.266 -15.1434Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.482 230.368L590.148 227.468C562.511 216.542 548.839 184.989 559.766 157.352L570.472 130.275C581.398 102.637 612.951 88.965 640.588 99.892L647.922 102.792C675.559 113.719 689.231 145.271 678.304 172.908L667.598 199.986C656.671 227.623 625.119 241.295 597.482 230.368Z",
    fill: "#959798"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M611.869 214.982L609.843 214.181C591.188 206.805 581.959 185.507 589.335 166.852L598.542 143.564C605.918 124.908 627.216 115.68 645.872 123.055L647.897 123.856C666.553 131.232 675.781 152.53 668.406 171.185L659.198 194.474C651.822 213.129 630.524 222.358 611.869 214.982Z",
    fill: "#252526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.059 165.93L651.434 177.939M597.482 230.368L590.148 227.468C562.511 216.542 548.839 184.989 559.766 157.352L570.472 130.275C581.398 102.637 612.951 88.965 640.588 99.892L647.922 102.792C675.559 113.719 689.231 145.271 678.304 172.908L667.598 199.986C656.671 227.623 625.119 241.295 597.482 230.368Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 629.5,
    cy: 169.5,
    rx: 29.5,
    ry: 38.5,
    fill: "#252526"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1158,
    height: 940,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.ee41a23772b10d4d57149f74fd92c668.svg";
export { ForwardRef as ReactComponent };